import {ProviderSpecialtyDTO} from './ProviderSpecialtyDTO';

export class ProviderSpecialtyLinkDTO {
  providerSpecialtyDTO: ProviderSpecialtyDTO;
}
